import React from 'react'
import PropTypes from 'prop-types'
import { Message } from 'semantic-ui-react'

export const ErrorMessage = ({ header, message }) => {
  return <Message error header={header} content={message} />
}

ErrorMessage.propTypes = {
  header: PropTypes.node,
  message: PropTypes.node,
}

ErrorMessage.defaultProps = {
  header: 'Something went wrong!',
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/ErrorMessage/index.js